import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as types from "../../../constants/ComponentConstants";
import * as layoutActions from "../../../actions/e-loketLayoutActions";
import { validatieStatussenLoaded } from "../../../actions/validatieStatusActions";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import { throwException } from "../../../actions/exceptionActions";
import { disablePage } from "../../../actions/settingActions";
import OrganisatorForm from "./OrganisatorForm";
import Section from "../../common/Section";
import redirector from "../../../util/redirector";
import OrganisatorPageHelper from "./OrganisatorPageHelper";
import EasterEggHandler from "../../common/EasterEggHandler";
import * as pageConstants from "../../../constants/EasterEggConstants";
import ScrollToFirstErrorComponent from "../../common/ScrollToFirstErrorComponent";

class OrganisatorPage extends ScrollToFirstErrorComponent {
    constructor(props, context) {
        super(props, context, true);

        this.filesHelper = null;
        this.state = {
            model: {
                validatiestatusses: [],
                organisator: {},
                contactpersoon: {},
                contactpersoonTijdensActiviteit: {},
                socialeMedia: {},
                verzekerd: {}
            },
            errors: null,
            hasUnsavedChanges: false,
            disabled: false,
            contactpersonen: [{ label: "andere", value: "ANDERE" }],
            showErrors: false,
            showAnbPopup: false,
            fileComponents: {},
            contactpersonenLabelValuePair: [],
            scrollToTop: false,
            shouldScrollToFirstError: false
        };

        this.pageHelper = new OrganisatorPageHelper(this, redirector);
        this.testFiller = new EasterEggHandler(this, pageConstants.WIJZIG_ORGANISATOR);
    }

    componentDidMount = () => {
        this.testFiller.bind();
        super.componentDidMount();
        this.pageHelper.init();
        window.parent.scrollTo(0, 0);
        this.setState({
            scrollToTop: false
        });
    };

    componentWillUnmount() {
        this.testFiller.unbind();
    }
    componentDidUpdate = () => {
        super.componentDidUpdate();

        if (this.state.scrollToTop) {
            window.parent.scrollTo(0, 450);
            this.setState({
                scrollToTop: false
            });
        }
    };

    handleOnSave = () => this.pageHelper.save();
    handleOnChangeChildModel = (event, childModelName) => this.pageHelper.changeChildModel(event, childModelName);
    handleOnGetChildModelError = (propertyName, childModelName) => this.pageHelper.getErrorForChildModelProperty(propertyName, childModelName);
    handleOnConfirmAnbPopup = () => this.pageHelper.confirmAnbPopup();

    isReadyToRender = () => {
        return !!this.filesHelper;
    };

    render() {
        if (!this.isReadyToRender())
            return null;

        const state = this.state;
        const props = this.props;
        const model = state.model;
        const postcodes = props.postcodes;
        const gemeenten = props.gemeenten;
        const landen = props.landen;
        const rechtspersoonlijkheidTypes = props.rechtspersoonlijkheidTypes;
        const disabled = props.disabled;
        const color = types.COLOR_ORANGE;
        const contactpersonen = state.contactpersonenLabelValuePair;
        const organisatorGegevensUrl = props.sportDBUrl;
        const validationMessageType = state.validationMessageType;
        const showAnbPopup = state.showAnbPopup;

        return (
            <Section title={"Gegevens van de organisator"} color={color}>
                <OrganisatorForm
                    model={model}
                    onChangeChildModel={this.handleOnChangeChildModel}
                    onSave={this.handleOnSave}
                    getError={this.handleOnGetChildModelError}
                    disabled={disabled}
                    postcodes={postcodes}
                    gemeenten={gemeenten}
                    landen={landen}
                    rechtspersoonlijkheidTypes={rechtspersoonlijkheidTypes}
                    organisatorGegevensUrl={organisatorGegevensUrl}
                    contactpersonen={contactpersonen}
                    color={color}
                    validationMessageType={validationMessageType}
                    showAnbPopup={showAnbPopup}
                    onConfirmAnbPopup={this.handleOnConfirmAnbPopup}
                />
            </Section>);
    }
}

OrganisatorPage.propTypes = {
    loadLayout: PropTypes.func
};

function mapStateToProps(state) {
    const landen = state.referentie.landen;
    const gemeenten = state.referentie.gemeenten;
    const postcodes = state.referentie.postcodes;
    const rechtspersoonlijkheidTypes = state.referentie.rechtspersoonlijkheidTypes;
    const bewijsVanVerzekeringFileTypes = state.settings.fileTypes[types.FileComponentNames.BEWIJS_VAN_VERZEKERING];
    const sportDBUrl = state.settings.sportDBUrl;
    const disabled = state.settings.disabled;
    const svlDossierId = state.settings.svlDossierId;

    return {
        landen: landen,
        gemeenten: gemeenten,
        postcodes: postcodes,
        rechtspersoonlijkheidTypes: rechtspersoonlijkheidTypes,
        bewijsVanVerzekeringFileTypes: bewijsVanVerzekeringFileTypes,
        disabled: disabled,
        sportDBUrl: sportDBUrl,
		svlDossierId: svlDossierId
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadOrganisatorLayout, dispatch),
        validatieStatussenLoaded: bindActionCreators(validatieStatussenLoaded, dispatch),
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
        throwException: bindActionCreators(throwException, dispatch),
        disablePage: bindActionCreators(disablePage, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(OrganisatorPage);
